// extracted by mini-css-extract-plugin
export default {"tertiaryColor":"#14d086","secondaryColor":"#fff","quaternaryColor":"#080f07"};